import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';

import { ScoreType } from '@/domain/impact/impact.entity';
import { ProjectTour } from '@/domain/project-tour/entities/project-tour.entity';
import {
  ProjectScores,
  ShowDetailsMode,
  ShowDetailsModesValues,
} from '@/ui/pages/app/components/project-page/ProjectScores';
import { ProjectScoresDetailsItemParams } from '@/ui/pages/app/components/project-page/ProjectScoresDetails/ProjectScoresDetails.types';

import { ProjectTourScoresDetailsCo2Custom } from './ProjectTourScoresDetailsCo2Custom';
import { ProjectTourScoresDetails } from './ProjectToursScoresDetails';

export function ProjectTourMainContent({
  project,
  onClickDetailsItem,
  setSelectedScoreType,
  onClickOpenOnTourSequence,
}: {
  project: ProjectTour;
  onClickDetailsItem: (params: ProjectScoresDetailsItemParams) => void;
  setSelectedScoreType: React.Dispatch<React.SetStateAction<ScoreType>>;
  onClickOpenOnTourSequence: (sequenceId: number) => void;
}) {
  const [showDetailsMode, setShowDetailsMode] =
    useState<ShowDetailsMode>('none');

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    // detect if mode is set in url params
    const urlParamMode = searchParams.get('mode');
    if (ShowDetailsModesValues.includes(urlParamMode as ShowDetailsMode)) {
      setShowDetailsMode(urlParamMode as ShowDetailsMode);
    }
    // remove mode in url params
    searchParams.delete('mode');
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);

  const onClickScore = (type: ScoreType) => {
    if (showDetailsMode === type) {
      setShowDetailsMode('none');
    } else {
      setShowDetailsMode(type);
      setSelectedScoreType(type);
    }
  };

  return (
    <Stack sx={{ mt: 3 }} spacing={3}>
      <ProjectScores
        project={project}
        showDetailsMode={showDetailsMode}
        onClickScore={onClickScore}
      />
      {showDetailsMode === 'co2' ? (
        <ProjectTourScoresDetailsCo2Custom
          project={project}
          showDetailsMode={showDetailsMode}
          onClickDetailsItem={onClickDetailsItem}
          onClickOpenOnTourSequence={onClickOpenOnTourSequence}
        />
      ) : (
        <ProjectTourScoresDetails
          project={project}
          showDetailsMode={showDetailsMode}
          onClickDetailsItem={onClickDetailsItem}
        />
      )}
    </Stack>
  );
}
